import { CHARACTER_SEPARATOR_IOT_KEY_NAME } from '../components/CycleChartPreview/constants';

const generateIdDevice = (serialNumber: string, device: string) => {
  return `${serialNumber}${CHARACTER_SEPARATOR_IOT_KEY_NAME}${device}`;
};

export default generateIdDevice;
